<div class="footer-legal">
  <span class="copyright">&copy; {{ currentYear }} InfinitForm</span>
  <ul class="footer-links" aria-label="Legal">
    <li><a [href]="aboutUrl()" target="_blank" rel="noopener">About<span class="visually-hidden"> (opens in a new tab)</span></a></li>
    <li><a [href]="eulaUrl()" target="_blank" rel="noopener">EULA<span class="visually-hidden"> (opens in a new tab)</span></a></li>
    <li><a [href]="privacyUrl()" target="_blank" rel="noopener">Privacy<span class="visually-hidden"> (opens in a new tab)</span></a></li>
  </ul>
</div>
<app-theme-picker class="footer-theme" />
